import isEmpty from 'lodash/isEmpty';

export interface FullNameParts {
  firstName: string;
  lastName: string;
}

export const splitFullName = (fullName: string | null | undefined): FullNameParts => {
  const trimmedFullName = fullName?.trim() ?? '';
  if (isEmpty(trimmedFullName)) {
    return { firstName: '', lastName: '' };
  }
  const [firstName = '', ...remainingParts] = trimmedFullName.split(/\s+/);
  return { firstName, lastName: remainingParts.join(' ') };
};
